import React from "react";
import { Box, Stack, Typography, Paper, FormControl } from "@mui/material";

/**
 * 金額表示共通コンポーネント画面
 * @returns
 */
const MedicalAccount = ({ name, amount = "" }) => {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing="2%"
    >
      <Typography>{name}</Typography>
      <Box width="25%">
        <FormControl fullWidth>
          <Paper elevation={0} variant="outlined" square>
            <Typography align="right" paddingRight="5%">
              {Number(amount).toLocaleString()}
            </Typography>
          </Paper>
        </FormControl>
      </Box>
      円
    </Stack>
  );
};

export default MedicalAccount;
